import { observer } from 'mobx-react-lite';
import React from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../colorVars';
import { updatePlugins } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/updatePlugins';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import CheckBox from '../../../../../../../atomic/formElements/checkBox/CheckBox';
import { EditableTableField } from '../../../../../../../atomic/inputs/editableTableField/EditableTableField';
import { Body3 } from '../../../../../../../atomic/text/Text';
import { IndividualPanelHeader } from '../IndividualPanelHeader';
import style from '../IndividualTacticStyle.module.css';

export const ConvictionCandleTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const updateTactic = (field, newValue) => {
      updatePlugins(
        'setup',
        { [field]: newValue },
        'CANDLE_TRIGGER',
        tradePlanId,
        null
      );
    };
    if (!tradePlan?.setupDetails['CONVICTION_CANDLE']) return null;
    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <IndividualPanelHeader />
            <tbody>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Candle Duration
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <EditableTableField
                    bodySize={3}
                    initialValue={
                      tradePlan.setupDetails['CONVICTION_CANDLE'].candleDuration
                    }
                    updateValue={(newValue) =>
                      updateTactic('candleDuration', newValue)
                    }
                    color={colors.lightGrey}
                    backgroundColor={colors.black}
                  />
                  <Body3
                    fontWeight={700}
                    color={colors.lightGrey}
                    margin="3px 3px 0 0"
                  >
                    min.
                  </Body3>
                </td>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Min. 1st Candle Height
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <Body3
                    fontWeight={700}
                    color={colors.lightGrey}
                    margin="3px 3px 0 0"
                  >
                    $
                  </Body3>
                  <EditableTableField
                    bodySize={3}
                    initialValue={
                      tradePlan.setupDetails['CONVICTION_CANDLE']
                        .minimumFirstCandleHeight
                    }
                    updateValue={(newValue) =>
                      updateTactic('minimumFirstCandleHeight', newValue)
                    }
                    color={colors.lightGrey}
                    backgroundColor={colors.black}
                  />
                </td>
              </tr>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Permitted Gap Pct.
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <EditableTableField
                    bodySize={3}
                    initialValue={
                      tradePlan.setupDetails['CONVICTION_CANDLE']
                        .permittedGapPct < -100000
                        ? 'N/A'
                        : tradePlan.setupDetails['CONVICTION_CANDLE']
                          .permittedGapPct
                    }
                    updateValue={(newValue) =>
                      updateTactic('permittedGapPct', newValue)
                    }
                    color={colors.lightGrey}
                    backgroundColor={colors.black}
                  />
                  <Body3
                    fontWeight={700}
                    color={colors.lightGrey}
                    margin="3px 3px 0 0"
                  >
                    %
                  </Body3>
                </td>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Candle Close Pct.
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <EditableTableField
                    bodySize={3}
                    initialValue={
                      tradePlan.setupDetails['CONVICTION_CANDLE'].candleClosePct
                    }
                    updateValue={(newValue) =>
                      updateTactic('candleClosePct', newValue)
                    }
                    color={colors.lightGrey}
                    backgroundColor={colors.black}
                  />
                  <Body3
                    fontWeight={700}
                    color={colors.lightGrey}
                    margin="3px 3px 0 0"
                  >
                    %
                  </Body3>
                </td>
              </tr>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Right Color Candle
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <CheckBox
                    fontSize="10px"
                    margin="auto 5px"
                    checked={
                      tradePlan.setupDetails['CONVICTION_CANDLE']
                        .rightColorCandle
                    }
                    onChange={(newValue) => {
                      if (
                        newValue !== 0 &&
                        newValue !==
                          tradePlan.setupDetails['CONVICTION_CANDLE']
                            .rightColorCandle
                      )
                        updateTactic('rightColorCandle', newValue);
                    }}
                  />
                </td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </TabPanel>
    );
  }
);

ConvictionCandleTacticPanel.tabsRole = 'TabPanel';
